import OrderHistory from "./orderHistory";

export default OrderHistory;
